<template>
    <div class="gs-affiliate-settings-tab gs-affiliate-settings-tab--tax">
        <div class="gs-affiliate-settings-tab__head">
            <h2>{{ $t('frontend_affiliate_settings_tax_info') }}</h2>
        </div>
        <div class="gs-affiliate-settings-tab__body gs-affiliate-settings__stack">
            <div class="gs-affiliate-settings__grid">
                <gs-field class="gs-field--span-2" :label="$t('frontend_legal_name')">
                    <text-input v-model="localForm.affiliate_legal_name" value="localForm.affiliate_legal_name"
                        :placeholder="$t('frontend_legal_name')" />
                </gs-field>
                <gs-field :label="$t('frontend_address')">
                    <text-input v-model="localForm.affiliate_legal_address" value="localForm.affiliate_legal_address"
                        :placeholder="$t('frontend_address')" />
                </gs-field>
                <gs-field :label="`${$t('frontend_address')} 2`">
                    <text-input v-model="localForm.affiliate_legal_address_2"
                        value="localForm.affiliate_legal_address_2" :placeholder="$t('frontend_address')" />
                </gs-field>
                <gs-field :label="$t('frontend_city')">
                    <text-input v-model="localForm.affiliate_legal_city" value="localForm.affiliate_legal_city"
                        :placeholder="$t('frontend_city')" />
                </gs-field>
                <gs-field :label="$t('frontend_state')">
                    <text-input v-model="localForm.affiliate_legal_state" value="localForm.affiliate_legal_state"
                        :placeholder="$t('frontend_state')" />
                </gs-field>
                <gs-field :label="$t('frontend_postal_code')">
                    <text-input v-model="localForm.affiliate_legal_zip_code" value="localForm.affiliate_legal_zip_code"
                        :placeholder="$t('frontend_postal_code')" />
                </gs-field>
                <gs-field :label="$t('frontend_country')">
                    <text-input v-model="localForm.affiliate_legal_country" value="localForm.affiliate_legal_country"
                        :placeholder="$t('frontend_country')" />
                </gs-field>
                <gs-field :label="$t('frontend_affiliate_settings_tax_id')">
                    <text-input v-model="localForm.affiliate_tax_id" value="localForm.affiliate_tax_id"
                        :placeholder="$t('frontend_affiliate_settings_tax_id')" />
                </gs-field>
            </div>

            <gs-field :label="$t('frontend_affiliate_settings_citizenship_status')">
                <fieldset class="gs-affiliate-settings__radio-cards">
                    <legend class="sr-only">{{ $t('frontend_affiliate_settings_citizenship_status') }}</legend>
                    <label class="gs-affiliate-settings__radio-card"
                        :class="{ 'is-active': localForm.affiliate_tax_resident_type == citizenshipType.id }"
                        v-for="(citizenshipType, index) in citizenshipTypes" :key="index">
                        <input type="radio" name="citizenship-type" :value="citizenshipType.id" class="sr-only"
                            v-model="localForm.affiliate_tax_resident_type" />
                        <span class="gs-affiliate-settings__radio-dot" aria-hidden="true"></span>
                        <p>{{ citizenshipType.title }}</p>
                    </label>
                </fieldset>
            </gs-field>

            <div v-if="localForm.affiliate_tax_resident_type > 0">
                <div class="gs-affiliate-settings__form-well" v-if="localForm.affiliate_tax_form">
                    <div class="gs-affiliate-settings__form-status">
                        <span class="gs-affiliate-settings__form-check"><gs-icon name="check" size="14"></gs-icon></span>
                        <span>
                            {{
                                localForm.affiliate_tax_resident_type == 1 ||
                                localForm.affiliate_tax_resident_type == 2
                                ? 'W-9'
                                : 'W-8BEN'
                            }}
                            {{ $t('frontend_form_filled_in') }}
                        </span>
                    </div>
                    <div class="gs-affiliate-settings__form-actions">
                        <gs-button variant="outline" size="sm" @click="previewTaxForm()">{{
                            $t('frontend_preview_file') }}</gs-button>
                        <gs-button variant="outline" size="sm" @click="downloadTaxForm()">{{
                            $t('frontend_download_file') }}</gs-button>
                        <gs-button variant="danger" size="sm" @click="removeTaxForm()">{{ $t('frontend_remove_file')
                        }}</gs-button>
                    </div>
                </div>
                <div class="gs-affiliate-settings__steps" v-else>
                    <div class="gs-affiliate-settings__step">
                        <span class="gs-affiliate-settings__step-badge">1</span>
                        <div class="gs-affiliate-settings__step-body">
                            <p>
                                <strong>{{ $t('frontend_step1') }}</strong>
                                {{ $t('frontend_please_download') }}
                                {{
                                    localForm.affiliate_tax_resident_type == 1 ||
                                    localForm.affiliate_tax_resident_type == 2
                                    ? 'W-9'
                                    : 'W-8BEN'
                                }}
                                {{ $t('frontend_form_by') }}
                                <template
                                    v-if="localForm.affiliate_tax_resident_type == 1 || localForm.affiliate_tax_resident_type == 2">{{
                                        $t('frontend_clicking_download_w9_form') }}</template>
                                <template
                                    v-if="localForm.affiliate_tax_resident_type == 3 || localForm.affiliate_tax_resident_type == 4">{{
                                        $t('frontend_clicking_download_w8_form') }}</template>
                            </p>
                            <div class="gs-affiliate-settings__step-action">
                                <gs-button v-if="localForm.affiliate_tax_resident_type == 1 ||
                                    localForm.affiliate_tax_resident_type == 2
                                    " variant="outline"
                                    @click="getAdminFileURL('Groove-Affiliate-W-9-localForm.pdf')">
                                {{ $t('frontend_download_w9_form') }}
                                </gs-button>
                                <div class="gs-affiliate-settings__w8-dropdown"
                                    v-else-if="localForm.affiliate_tax_resident_type == 3 || localForm.affiliate_tax_resident_type == 4">
                                    <gs-name-select
                                        placeholder="Download W-8BEN Form"
                                        size="full"
                                        :actions="w8TypesActions"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="gs-affiliate-settings__step">
                        <span class="gs-affiliate-settings__step-badge">2</span>
                        <div class="gs-affiliate-settings__step-body">
                            <p>
                                <strong>{{ $t('frontend_step2') }}</strong>
                                {{ $t('frontend_fill_required_details') }}
                            </p>
                        </div>
                    </div>
                    <div class="gs-affiliate-settings__step">
                        <span class="gs-affiliate-settings__step-badge">3</span>
                        <div class="gs-affiliate-settings__step-body">
                            <p>
                                <strong>{{ $t('frontend_step3') }}</strong>
                                {{ $t('frontend_upload_complete_pdf') }}
                            </p>
                            <vue-dropzone id="customdropzone" ref="myVueDropzone" :options="dropzoneOptions"
                                :use-custom-slot="true" @vdropzone-file-added="fileAdded" @vdropzone-error="() => { }"
                                @vdropzone-upload-progress="() => { }" @vdropzone-total-upload-progress="() => { }"
                                @vdropzone-success="() => { }">
                                <div class="dropzone-custom-content">
                                    <div class="gs-affiliate-settings__dropzone-content">
                                        <div class="gs-affiliate-settings__dropzone-title">
                                            {{
                                                $t('frontend_groovemember_files_drag_and_drop')
                                            }}
                                        </div>
                                        <div>
                                            - {{ $t('frontend_groovemember_files_or') }} -
                                        </div>
                                        <div>
                                            <gs-button variant="outline" size="sm">
                                                {{ $t('frontend_groovemember_select_file') }}
                                            </gs-button>
                                        </div>
                                        <div>
                                           {{ $t('frontend_max_size')  }}
                                        </div>
                                    </div>
                                </div>
                            </vue-dropzone>
                            <div class="gs-affiliate-settings__upload-actions">
                                <gs-button v-if="this.upload_file.file" variant="outline"
                                    @click="uploadFilesToServer()">
                                    {{ $t('frontend_groovemember_files_upload_file') }}
                                </gs-button>
                                <gs-button v-else disabled variant="outline">
                                    {{ $t('frontend_groovemember_files_upload_file') }}
                                </gs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer class="gs-affiliate-settings-tab__footer">
            <gs-button v-if="isValid" variant="primary" size="md" @click="saveAffiliateSettings()">{{
                $t('frontend_save')
            }}</gs-button>
            <gs-button v-else disabled variant="primary" size="md">{{ $t('frontend_save')
            }}</gs-button>
        </footer>
        <confirm-modal
            name="confirm-modal"
            :message-content="$t('frontend_swal_remove_tax_form_text')"
            :button-text="$t('frontend_swal_remove_tax_form_btn_confirm')"
            button-size="auto"
            @confirm="removeTaxForm"
        />
    </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone';
import SimpleDropdown from '@/components/SimpleDropdown';
import axios from 'axios';
import CheckCircleIcon from '@/assets/images/icons/CheckCircleIcon.svg';
import ChevronRightIcon from '@/assets/images/icons/ChevronRightIcon.svg';

export default {
    components: {
        vueDropzone: vue2Dropzone,
        SimpleDropdown,
        CheckCircleIcon,
        ChevronRightIcon,
    },
    props: {
        form: {
            required: true,
        },
        validator: {
            required: true,
        },
        saveAffiliateSettings: {
            required: true,
            type: Function,
        }

    },
    watch: {
        localForm: {
            handler() {
                this.$emit('update-form', this.localForm);
            },
            deep: true,
        },
        'localForm.affiliate_tax_resident_type': function (newVal, oldVal) {
            if (oldVal > 0 && newVal > 0) {
                if (newVal == 1 || newVal == 2) {
                    if (this.addedW9Form != '') {
                        this.localForm.affiliate_tax_form = this.addedW9Form;
                    } else {
                        this.localForm.affiliate_tax_form = '';
                    }
                } else if (newVal == 3 || newVal == 4) {
                    if (this.addedW8Form != '') {
                        this.localForm.affiliate_tax_form = this.addedW8Form;
                    } else {
                        this.localForm.affiliate_tax_form = '';
                    }
                }
            }
        },

        'localForm.affiliate_tax_form': function (newVal, oldVal) {
            if (newVal != '' && this.localForm.affiliate_tax_resident_type > 0) {
                if (this.localForm.affiliate_tax_resident_type == 1 || this.localForm.affiliate_tax_resident_type == 2) {
                    this.addedW9Form = newVal;
                } else {
                    this.addedW8Form = newVal;
                }
            }
        },
    },
    data() {
        return {
            localForm: this.form,
            addedW8Form: '',
            addedW9Form: '',
            upload_file: {
                name: '',
                file: null,
            },
            w8Types: [
                {
                    id: 'Groove-Affiliate-W-8-BEN-localForm.pdf',
                    name: 'Download W-8BEN For An Individual',
                    disabled: false,
                },
                {
                    id: 'Groove-Affiliate-W-8-BENE-localForm.pdf',
                    name: 'Download W-8BEN-E For An Entity',
                    disabled: false,
                },
            ],
            dropzoneOptions: {
                url: `${window.config.apiUrl}/upload`,
                timeout: 99999999,
                maxFiles: 1,
                maxFilesize: 2,
                autoProcessQueue: false,
                autoQueue: true,
                method: 'put',
                acceptedFiles: '.pdf',
            },
            citizenshipTypes: [
                {
                    id: 1,
                    title: this.$t('frontend_affiliate_us_citizen_in_us'),
                    description: '',
                },
                {
                    id: 2,
                    title: this.$t('frontend_affiliate_us_citizen_in_non_us'),
                    description: '',
                },
                {
                    id: 3,
                    title: this.$t('frontend_affiliate_non_us_citizen_in_us'),
                    description: '',
                },
                {
                    id: 4,
                    title: this.$t('frontend_affiliate_non_us_citizen_in_non_us'),
                    description: '',
                },
            ],
            currentUploadedFile: null,

        }
    },
    computed: {
        w8TypesActions() {
            return this.w8Types.map((type) => {
                return {
                    text: type.name,
                    callback: () => this.downloadW8Form(type.id)
                };
            });
        },
        isValid() {
            return !this.validator.form.affiliate_legal_name.$invalid &&
                !this.validator.form.affiliate_legal_address.$invalid &&
                !this.validator.form.affiliate_legal_city.$invalid &&
                !this.validator.form.affiliate_legal_state.$invalid &&
                !this.validator.form.affiliate_legal_country.$invalid &&
                !this.validator.form.affiliate_legal_zip_code.$invalid &&
                !this.validator.form.affiliate_tax_resident_type.$invalid &&
                !this.validator.form.affiliate_tax_id.$invalid &&
                !this.validator.form.affiliate_tax_form.$invalid

        }


    },
    methods: {
        previewTaxForm() {
            this.openLink(
                `${window.config.apiUrl}/download-user-files/${this.localForm.affiliate_tax_form}`,
                '_blank'
            );
        },
        downloadTaxForm() {
            this.openLink(
                `${window.config.apiUrl}/download-user-files/${this.localForm.affiliate_tax_form}?is_download=1`,
                '_blank'
            );
        },
        openConfirmModal() {
            this.$root.$emit('modal-open', 'confirm-modal');
        },
        async removeTaxForm() {
            this.localForm.affiliate_tax_form = '';
        },
        async getAdminFileURL(fileName) {
            const sellAppUrl = this.whitelabelAppData('sell').url;
            const url = `${window.gdEnv.VUE_APP_API_URL}${sellAppUrl}download-admin-files/${fileName}`;
            this.openLink(url, '_blank');
        },
        downloadW8Form(id) {
            this.getAdminFileURL(id);
        },
        fileAdded(addedFile) {
            if (this.currentUploadedFile) {
                this.$refs.myVueDropzone.removeFile(this.currentUploadedFile);
            }
            this.currentUploadedFile = addedFile;
            this.upload_file.file = addedFile;
        },
        async uploadFilesToServer() {
            if (this.upload_file) {
                const self = this;
                this.$loader.start('uploadFilesToServer');
                axios
                    .post(`${window.config.apiUrl}/get-pre-sign-url`, {
                        fileName: this.upload_file.file.name,
                    })
                    .then(async (res) => {
                        this.uploadedFileName = res.data.file;
                        // this.affiliate_tax_form = res.data.file;
                        const uninterceptedAxiosInstance = axios.create();
                        uninterceptedAxiosInstance
                            .put(res.data.postEndpoint, this.upload_file.file, {
                                onUploadProgress: (p) => {
                                    this.uploadProgressStatus = Math.round(
                                        (p.loaded / p.total) * 100
                                    );

                                    if (this.upload_file.file.previewElement) {
                                        const progressElement =
                                            this.upload_file.file.previewElement.querySelector(
                                                '[data-dz-uploadprogress]'
                                            );
                                        progressElement.style.width = `${this.uploadProgressStatus}%`;
                                        progressElement.textContent = `${this.uploadProgressStatus}%`;
                                    }
                                },
                            })
                            .then(async (uploadRes) => {
                                this.localForm.affiliate_tax_form = this.uploadedFileName;
                                this.$loader.end('uploadFilesToServer');

                            })
                            .catch((e) => {
                                this.$loader.end('uploadFilesToServer');
                                this.onUploaderError(
                                    this.upload_file.file,
                                    'Error occurred while uploading file'
                                );
                            });
                    });
            }
        },
        async openLink(link, linkTarget) {
            let a = document.createElement('a');
            a.target = linkTarget;
            a.href = link.replace(/^http:\/\//i, 'https://');
            a.click();
        }
    }
}
</script>

